module.exports = __webpack_public_path__ + "img/46.a568588f.jpg";